import getCSSProp from 'www/utils/get/getCSSProp'

/**
 * @description
 *
 * Возвращает обрезанное CSS-значение DOM-элемента (например высоту без 'px')
 *
 * @param { HTMLElement } node - узел, свойство которого необходимо вернуть
 * @param {string} prop - название свойства
 * @param {boolean} float - метод округления
 *
 * @returns {number | NaN} - значение указанного свойства
 */

function getCSSPropRound(node, prop, float) {
  const method = float ? parseFloat : parseInt

  return method(getCSSProp(node, prop))
}

export default getCSSPropRound
